import { AfterViewInit, Directive, EventEmitter, OnDestroy, Output } from '@angular/core';

/** A fetched message is not a receipt: acknowledge only after its view has been rendered in a visible tab. */
@Directive({ selector: '[messageDisplayed]', standalone: true })
export class MessageDisplayedDirective implements AfterViewInit, OnDestroy {
  @Output() messageDisplayed = new EventEmitter<void>();
  private frame?: number;
  private destroyed = false;
  private emitted = false;
  private readonly visible = () => {
    if (document.visibilityState !== 'visible' || this.emitted || this.destroyed) return;
    this.frame = requestAnimationFrame(() => {
      if (!this.destroyed && !this.emitted && document.visibilityState === 'visible') {
        this.emitted = true;
        this.messageDisplayed.emit();
      }
    });
  };
  ngAfterViewInit(): void {
    document.addEventListener('visibilitychange', this.visible);
    this.visible();
  }
  ngOnDestroy(): void {
    this.destroyed = true;
    document.removeEventListener('visibilitychange', this.visible);
    if (this.frame !== undefined) cancelAnimationFrame(this.frame);
  }
}
